<template>
  <div>
    <QCard v-if="extra.getMotivationText().length" class="extra-motivation-card q-mt-lg">
      <QCardSection>
        <div class="text-h3 text-secondary text-center">
          {{ $t("ETAB.PAGES.EXTRA.@MOTIVATION_TITLE") }}
        </div>
      </QCardSection>

      <QCardSection>
        {{ extra.getMotivationText(textOverflowLimit) }}
      </QCardSection>

      <QCardActions v-if="extra.getMotivationText().length > textOverflowLimit" vertical>
        <QBtn
flat
              color="secondary"
              no-caps
              :label="$t('ETAB.BUTTONS.@SEE_MORE')"
              class="btn"
              @click="showMore"
        />
      </QCardActions>
    </QCard>
    <MotivationModal v-model:opened="motivationModalOpened" :motivation-text="extra.getMotivationText()" />
  </div>
</template>

<script>
import { ExtraModel } from "@core/models";
import MotivationModal from "./Motivation.modal.vue";

const TEXT_OVERFLOW_LIMIT = 100;

export default {
  components: { MotivationModal },
  props: {
    extra: {
      type: Object,
      default: () => new ExtraModel(),
    },
  },
  data() {
    return {
      textOverflowLimit: TEXT_OVERFLOW_LIMIT,
      motivationModalOpened: false,
    };
  },
  methods: {
    showMore() {
      this.motivationModalOpened = true;
    },
  },
};
</script>

<style lang="scss">
.extra-motivation-card {
  box-shadow: $card-shadow;
}
</style>
